import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { RloApplicationSortFormHelper,RloApplicationSortFormState} from './rlo-application-sort-form.helper';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core'; 
import { RloapplicationService } from '../rloapplication-service/rloapplication.service';
import { Rloapplication } from '../rloapplication-service/rloapplication.model';

 
@Component({
 selector: 'app-rlo-application-sort-form',
  templateUrl: './rlo-application-sort-form.component.html',
  styleUrls: ['./rlo-application-sort-form.component.scss'],
  providers : [ RloApplicationSortFormHelper,]
  })

export class RloApplicationSortFormComponent extends BaseFpxFormComponent<RloApplicationSortFormHelper, RloApplicationSortFormState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public rloApplicationSortFormHelper: RloApplicationSortFormHelper,
    private validatorService: ValidatorService,
    public rloapplicationService:RloapplicationService

  ) {
    super(formBuilder, router,controlContainer, rloApplicationSortFormHelper);
  }

   protected override doPreInit(): void {

  this.addFormControl("applicantName", "", [], [], "change", 1, false, 0);
    this.addFormControl("arn", "", [], [], "change", 1, false, 0);
    this.addFormControl("type", "", [], [], "change", 1, false, 0);
    this.addFormControl("stage", "", [], [], "change", 1, false, 0);
    this.addFormControl("period", "", [], [], "change", 1, false, 0);
    this.addFormControl("tat", "", [], [], "change", 1, false, 0);		   		 
  }
 

  protected override doPostInit(): void {
   
  }
  
}
